import { render, staticRenderFns } from "./platinum_mobile.vue?vue&type=template&id=440e3fe3&scoped=true&"
import script from "./platinum_mobile.vue?vue&type=script&lang=js&"
export * from "./platinum_mobile.vue?vue&type=script&lang=js&"
import style0 from "./platinum_mobile.vue?vue&type=style&index=0&id=440e3fe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e3fe3",
  null
  
)

export default component.exports